/* ==========================================================================
   LAST PALLET - cart drawer

   Adding flooring keeps you on the page: the count animates, a drawer slides
   in with what you just added, and checkout is one click from there. No page
   reload, no jumping to /cart and losing your place in the lot list.

   Everything here is an enhancement over a working baseline. The product form
   is a real Shopify {% form 'product' %} that posts to /cart/add, and the
   drawer's checkout button is a real form posting to /cart with name="checkout".
   With JavaScript off you get a normal page navigation to the cart instead -
   slower, but it still sells.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__lpCartDrawer) { return; }
  window.__lpCartDrawer = true;

  var drawer, panel, itemsEl, subtotalEl, countEl, lastFocused;

  function money(cents, sample) {
    var n = (cents / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
    if (!sample) { return '$' + n; }
    var symbol = sample.replace(/[\d.,\s]/g, '') || '$';
    return symbol + n;
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ------------------------------------------------------------------ */

  function build() {
    if (drawer) { return; }

    drawer = document.createElement('div');
    drawer.className = 'cart-drawer';
    drawer.setAttribute('hidden', '');
    drawer.innerHTML =
      '<div class="cart-drawer__scrim" data-drawer-close></div>' +
      '<aside class="cart-drawer__panel" role="dialog" aria-modal="true" aria-label="Your cart">' +
        '<header class="cart-drawer__head">' +
          '<span class="eyebrow eyebrow--accent">Your cart</span>' +
          '<button type="button" class="cart-drawer__close" data-drawer-close aria-label="Close cart">&times;</button>' +
        '</header>' +
        '<div class="cart-drawer__items" data-drawer-items></div>' +
        '<footer class="cart-drawer__foot">' +
          '<div class="cart-drawer__row">' +
            '<span class="mono">Subtotal</span>' +
            '<strong data-drawer-subtotal></strong>' +
          '</div>' +
          '<p class="mono cart-drawer__note">Taxes, discounts and shipping are calculated at checkout.</p>' +
          '<form action="/cart" method="post">' +
            '<button type="submit" name="checkout" class="btn btn--accent cart-drawer__checkout">Check out</button>' +
          '</form>' +
          '<a class="btn btn--ghost cart-drawer__view" href="/cart">View full cart</a>' +
        '</footer>' +
      '</aside>';

    document.body.appendChild(drawer);
    panel = drawer.querySelector('.cart-drawer__panel');
    itemsEl = drawer.querySelector('[data-drawer-items]');
    subtotalEl = drawer.querySelector('[data-drawer-subtotal]');

    drawer.addEventListener('click', function (evt) {
      if (evt.target.hasAttribute('data-drawer-close')) { close(); }
    });

    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape' && !drawer.hasAttribute('hidden')) { close(); }
    });
  }

  function open() {
    build();
    lastFocused = document.activeElement;
    drawer.removeAttribute('hidden');
    // next frame, so the transition has a start state to animate from
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    var closeBtn = drawer.querySelector('.cart-drawer__close');
    if (closeBtn) { closeBtn.focus(); }
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    if (!drawer) { return; }
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    window.setTimeout(function () {
      if (!drawer.classList.contains('is-open')) { drawer.setAttribute('hidden', ''); }
    }, 300);
    if (lastFocused && lastFocused.focus) { lastFocused.focus(); }
  }

  /* ------------------------------------------------------------------ */

  function render(cart) {
    build();

    var sample = document.querySelector('[data-price]');
    sample = sample ? sample.textContent : '';

    if (!cart.items || !cart.items.length) {
      itemsEl.innerHTML = '<p class="cart-drawer__empty mono">Your cart is empty.</p>';
      subtotalEl.textContent = money(0, sample);
      return;
    }

    itemsEl.innerHTML = cart.items.map(function (item) {
      var sqft = item.properties && item.properties._sqft_per_carton;
      var coverage = '';
      if (sqft) {
        var total = Math.round(parseFloat(sqft) * item.quantity);
        if (isFinite(total) && total > 0) {
          coverage = '<div class="cart-drawer__meta mono">' + total + ' sq ft coverage</div>';
        }
      }
      var img = item.image
        ? '<img src="' + esc(item.image) + '" alt="" width="64" height="64" loading="lazy">'
        : '';
      return '' +
        '<div class="cart-drawer__item">' +
          img +
          '<div class="cart-drawer__item-body">' +
            '<a class="cart-drawer__name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
            '<div class="cart-drawer__meta mono">' + item.quantity +
              (item.quantity === 1 ? ' carton' : ' cartons') + '</div>' +
            coverage +
            '<div class="cart-drawer__meta mono">' + money(item.line_price, sample) + '</div>' +
          '</div>' +
        '</div>';
    }).join('');

    subtotalEl.textContent = money(cart.total_price, sample);
  }

  function bumpCount(count) {
    countEl = document.querySelector('[data-cart-count]');
    if (!countEl) { return; }
    countEl.textContent = count;
    countEl.classList.remove('is-bumped');
    // force reflow so the animation restarts on repeat adds
    void countEl.offsetWidth;
    countEl.classList.add('is-bumped');
    var link = countEl.closest('a');
    if (link) { link.setAttribute('aria-label', 'Cart, ' + count + ' items'); }
  }

  function refresh(andOpen) {
    if (!window.fetch) { return Promise.resolve(); }
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        bumpCount(cart.item_count);
        render(cart);
        if (andOpen) { open(); }
      })
      .catch(function () { /* header count stays as server-rendered */ });
  }

  window.LastPalletCart = { open: open, close: close, refresh: refresh };

  /* ------------------------------------------------------------------ */
  /* Header shrink-on-scroll                                             */
  /* ------------------------------------------------------------------ */

  function initHeaderState() {
    var mast = document.querySelector('.masthead');
    if (!mast) { return; }
    var ticking = false;

    function paint() {
      ticking = false;
      mast.classList.toggle('is-stuck', window.scrollY > 24);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(paint); }
    }, { passive: true });
    paint();
  }

  function boot() {
    initHeaderState();
    var trigger = document.querySelector('[data-cart-count]');
    if (trigger) {
      var link = trigger.closest('a');
      if (link) {
        link.addEventListener('click', function (evt) {
          if (!window.fetch) { return; }
          evt.preventDefault();
          refresh(true);
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
